var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavingsColoured = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0625 29.7083H28.5095C27.0538 29.7083 25.874 28.5286 25.874 27.0729V25.1563C25.874 23.7005 27.0538 22.5208 28.5095 22.5208H33.0625V21.3229C33.0625 20.6243 32.7846 19.9535 32.291 19.459C31.7965 18.9654 31.1257 18.6875 30.4271 18.6875C27.1084 18.6875 20.3291 18.6875 17.0104 18.6875C16.3118 18.6875 15.641 18.9654 15.1465 19.459C14.6529 19.9535 14.375 20.6243 14.375 21.3229V30.9063C14.375 31.6049 14.6529 32.2757 15.1465 32.7702C15.641 33.2638 16.3118 33.5417 17.0104 33.5417H30.4271C31.1257 33.5417 31.7965 33.2638 32.291 32.7702C32.7846 32.2757 33.0625 31.6049 33.0625 30.9063V29.7083ZM33.0625 23.9583V28.2708H28.5095C27.8482 28.2708 27.3115 27.7342 27.3115 27.0729V25.1563C27.3115 24.495 27.8482 23.9583 28.5095 23.9583H33.0625ZM28.9896 25.1563C29.5186 25.1563 29.9479 25.5856 29.9479 26.1146C29.9479 26.6436 29.5186 27.0729 28.9896 27.0729C28.4606 27.0729 28.0312 26.6436 28.0312 26.1146C28.0312 25.5856 28.4606 25.1563 28.9896 25.1563Z",
    fill: "#F48FBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6352 17.7295H30.4259C30.609 17.7295 30.791 17.7438 30.9703 17.7707L31.4245 16.7951C31.5922 16.4357 31.437 16.0083 31.0776 15.8406L24.997 13.0049C24.6376 12.8372 24.2102 12.9934 24.0425 13.3528L23.5278 14.4558L26.6903 15.9297C27.3899 16.2565 27.7589 17.004 27.6352 17.7295Z",
    fill: "#F48FBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6543 17.7262H26.6425C26.792 17.3716 26.6358 16.9595 26.2841 16.7957L20.2035 13.96C19.8441 13.7923 19.4167 13.9485 19.249 14.3078L17.6543 17.7262Z",
    fill: "#F48FBB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavingsColoured);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/savings_coloured.ecdf1a33a27dea54cd75ea545d98574c.svg";